import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface Layers4675259IconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const Layers4675259Icon = ({ className, ...props }: Layers4675259IconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_13_334)">
      <path
        d="M22.7078 16.9697C23.0726 16.7741 23.5275 16.9117 23.7234 17.2764C23.9191 17.6414 23.7817 18.0962 23.4167 18.292L14.0945 23.293L14.0886 23.2959L13.8503 23.4121C13.2851 23.6679 12.6581 23.8105 11.9998 23.8105C11.2475 23.8105 10.5359 23.6245 9.91089 23.2959L9.90503 23.293L0.582764 18.292C0.218017 18.0961 0.0804372 17.6413 0.276123 17.2764C0.471882 16.9116 0.926857 16.7743 1.29175 16.9697L10.6082 21.9688L10.6091 21.9678C11.0245 22.1862 11.497 22.3105 11.9998 22.3105C12.5024 22.3105 12.975 22.187 13.3904 21.9688L22.7078 16.9697ZM22.7078 12.2822C23.0726 12.0866 23.5275 12.2241 23.7234 12.5889C23.9191 12.9539 23.7817 13.4087 23.4167 13.6045L14.0945 18.6055L14.0886 18.6084L13.8503 18.7246C13.2851 18.9804 12.6581 19.123 11.9998 19.123C11.2475 19.123 10.5359 18.937 9.91089 18.6084L9.90503 18.6055L0.582764 13.6045C0.218007 13.4086 0.0804349 12.9538 0.276123 12.5889C0.471878 12.2241 0.926847 12.0868 1.29175 12.2822L10.6082 17.2812L10.6091 17.2803C11.0245 17.4987 11.497 17.623 11.9998 17.623C12.5024 17.623 12.975 17.4995 13.3904 17.2812L22.7078 12.2822ZM11.9998 0.185547C12.7498 0.185547 13.4591 0.371467 14.0828 0.698242L14.0837 0.697266L22.4021 4.9834L22.408 4.98633C23.2412 5.42457 23.8121 6.30041 23.8123 7.31055C23.8123 8.32086 23.2412 9.19645 22.408 9.63477L22.4021 9.6377L14.0837 13.9238L14.0828 13.9229C13.459 14.2497 12.7499 14.4355 11.9998 14.4355C11.2493 14.4355 10.5396 14.25 9.91577 13.9229V13.9238L1.59741 9.6377L1.59155 9.63477C0.758365 9.19638 0.187256 8.32069 0.187256 7.31055C0.187371 6.30047 0.758271 5.4246 1.59155 4.98633L1.59741 4.9834L9.91577 0.698242C10.5396 0.371139 11.2493 0.185588 11.9998 0.185547ZM11.9998 1.68555C11.497 1.68559 11.0245 1.80992 10.6091 2.02832L10.6033 2.03125L2.28979 6.31348C1.93009 6.50264 1.68737 6.87914 1.68726 7.31055C1.68726 7.74195 1.93008 8.1183 2.28979 8.30762L2.28882 8.30859L10.6033 12.5898L10.6091 12.5928C11.0245 12.8112 11.497 12.9355 11.9998 12.9355C12.5026 12.9355 12.9749 12.8112 13.3904 12.5928L13.3962 12.5898L21.7097 8.30859V8.30762C22.0696 8.11834 22.3123 7.74205 22.3123 7.31055C22.3121 6.87914 22.0685 6.50265 21.7087 6.31348L13.3962 2.03125L13.3904 2.02832C12.975 1.80998 12.5024 1.68555 11.9998 1.68555Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_13_334">
        <rect
          fill="white"
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Layers4675259Icon;
